/**
 * Where a seller stands when trading opens: in the sellers zone, above the store sell line.
 * The picture is drawn on that price, so starting on the line puts the seller on top of it.
 */
export function sellerOpeningPrice(sell: number, maxPrice: number) {
  const room = maxPrice - sell;
  if (room <= 1) return maxPrice;
  return sell + Math.max(1, Math.round(room * 0.55));
}
